// --- Core ---
import {addDays, nextSunday} from "date-fns";
import {useMemo} from "react";
import {useIntl} from "react-intl";
import {map, range} from "underscore";

/**
 * List of day names in the specified locale
 *
 * IMPORTANT: Sunday is the zero index
 */
function daysForLocale(localeName = 'de', length: 'short' | 'long' | 'narrow' = 'short'): [string, string, string, string, string, string, string] {
  const {format} = new Intl.DateTimeFormat(localeName, {weekday: length});

  return map(range(0, 7), (day) => format(addDays(nextSunday(new Date()), day))) as [string, string, string, string, string, string, string];
}

const useDayNames = (length: 'short' | 'long' | 'narrow') => {
  const intl = useIntl();

  return useMemo(() => daysForLocale(intl.locale, length), [intl.locale, length]);
};

export {
  useDayNames
};
